// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".svg-gradient[data-v-44234816]{position:relative}.svg-gradient svg[data-v-44234816]{position:absolute;opacity:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
